// Slice de UI da feature queue. Filtro corrente + loja selecionada.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { QueueFilter } from './api';

export interface QueueUiState {
  selectedFilter: QueueFilter;
  /** `'all'` = todas as lojas; `null` = ainda não resolvido (cai no default
   * "primeira loja criada" assim que a lista de lojas carrega). */
  selectedStoreId: string | null;
}

const initialState: QueueUiState = {
  selectedFilter: 'aguardando',
  selectedStoreId: null,
};

const slice = createSlice({
  name: 'queueUi',
  initialState,
  reducers: {
    queueFilterChanged(state, action: PayloadAction<QueueFilter>) {
      state.selectedFilter = action.payload;
    },
    // Default "primeira loja": só seta enquanto ninguém escolheu nada ainda, pra
    // não sobrescrever a escolha do usuário num re-render posterior.
    queueStoreInitialized(state, action: PayloadAction<string>) {
      if (state.selectedStoreId === null) {
        state.selectedStoreId = action.payload;
      }
    },
    queueStoreChanged(state, action: PayloadAction<string>) {
      state.selectedStoreId = action.payload;
    },
  },
});

export const { queueFilterChanged, queueStoreInitialized, queueStoreChanged } = slice.actions;
export const queueUiReducer = slice.reducer;

export const selectQueueFilter = (s: { queueUi: QueueUiState }): QueueFilter =>
  s.queueUi.selectedFilter;
export const selectQueueStore = (s: { queueUi: QueueUiState }): string | null =>
  s.queueUi.selectedStoreId;
